import React from 'react';
import { motion } from 'framer-motion';
export function OpeningHook() {
  return <section className="py-24 bg-cream relative" data-id="element-131">
      <div className="max-w-3xl mx-auto px-6 text-center" data-id="element-132">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} data-id="element-133">
          <p className="text-2xl md:text-3xl font-serif italic text-navy/90 leading-relaxed mb-12" data-id="element-134">
            "Son las 3:00 AM. Estás sentada en el borde de la cama, con los ojos
            ardiendo y el corazón acelerado, meciendo a tu bebé por cuarta vez
            en la noche. Tienes miedo de moverte. Tienes miedo de que, al tocar
            el colchón, sus ojos se abran y el ciclo comience de nuevo."
          </p>

          <div className="w-16 h-px bg-amber mx-auto mb-12" data-id="element-135"></div>

          <p className="text-lg md:text-xl text-navy/80 leading-relaxed" data-id="element-136">
            No estás fallando como mamá. Simplemente estás operando con un
            "tanque de combustible" vacío. El agotamiento extremo no es una
            medalla de honor, es una crisis que tiene solución.
          </p>
        </motion.div>
      </div>
    </section>;
}